import { isTabletViewport } from '../utilities/ViewportHelpers'

let serviceHeroElement: HTMLElement = null;

document.addEventListener('DOMContentLoaded', () => {
    serviceHeroElement = document.querySelector('.service-hero');

    if (serviceHeroElement) {
        toggleServiceHeroVideo();
    }
})

const toggleServiceHeroVideo = () => {
    const videoElement = document.getElementById('serviceHeroVideo') as HTMLVideoElement;
    if (videoElement) {
        const desktopSrc = videoElement.getAttribute('data-source-desktop');
        const tabletSrc = videoElement.getAttribute('data-source-tablet');
        const mobileSrc = videoElement.getAttribute('data-source-mobile');

        let loopbackTime: number;
        let animateTime: number;

        const mobileElement = document.querySelector<HTMLElement>('.navbar-toggler');
        let isSrcSet = false;
        if (mobileElement && mobileElement.offsetParent !== null) {
            if (tabletSrc && tabletSrc.length && isTabletViewport()) {
                // play tablet
                videoElement.src = tabletSrc;
                isSrcSet = true;
            } else if (mobileSrc && mobileSrc.length) {
                // play mobile
                videoElement.src = mobileSrc;
                isSrcSet = true;
            }
            loopbackTime = parseFloat(videoElement.getAttribute('data-loopback-mobile'));
            animateTime = parseFloat(videoElement.getAttribute('data-animate-time-mobile'));
        } else if (desktopSrc && desktopSrc.length) {
            // play desktop
            videoElement.src = desktopSrc;
            isSrcSet = true;

            loopbackTime = parseFloat(videoElement.getAttribute('data-loopback-desktop'));
            animateTime = parseFloat(videoElement.getAttribute('data-animate-time-desktop'));
        }

        if (!isSrcSet) {
            serviceHeroElement.classList.add('video-disabled');
        }

        videoElement.addEventListener('ended', function() {
            this.currentTime = loopbackTime;
            this.play();
        });

        if (isSrcSet) {
            videoElement.load();
            videoElement.play();
        }

        // determine when the N second mark has been reached
        let hasTimeBeenReached = false;
        const onVideoTimeUpdate = () => {
            if (videoElement.currentTime >= animateTime && !hasTimeBeenReached) {
                hasTimeBeenReached = true;
                serviceHeroElement.classList.add('activate-content-animation');
            } else {
                window.requestAnimationFrame(onVideoTimeUpdate);
            }
        }
        window.requestAnimationFrame(onVideoTimeUpdate);
    } else {
        // when no video, play content animation immediately
        serviceHeroElement.classList.add('activate-content-animation');
    }
}